import template from './ui-crud-form.html';

/**
 * Componente que representa a una vista de CRUD. Util para poder
 * unificar el look & feel de los distintos formularios de la aplicación.
 * 
 * Ejemplo de utilización:
 * 
    <ui-crud-form icon-classes="glyph-icon icon-calendar-o" list-state="home.franjas-horarias.list" 
                  do-submit="vm.doSubmit()" submitted-flag="vm.submitted" view="vm.view">
      <ui-crud-header>
        <h2>{{'Administración de franjas horarias' | translate}}</h2>
      </ui-crud-header>

      <ui-crud-actions>
        <a auth permissions="'aprobar_marcaciones'" ng-click="vm.gotoConfigurarForm()" class="btn btn-link font-blue"
          title="">
          <i class="fa fa-gear font-size-14 opacity-hover"></i> {{'Aprobar' | translate}}
        </a>
      </ui-crud-actions>

      <ui-crud-title>{{ ::vm.title }}</ui-crud-title>

      <ui-crud-body>
        <validated-text-input model="vm.model.nombre" class="col-lg-12" form="form" name="nombre" submitted-flag="vm.submitted"
          classes="form-group" input-type="text" label="{{'Nombre' | translate}}" is-disabled="vm.view" is-required="true">
        </validated-text-input>
      </ui-crud-body>
    </ui-crud-form>
 * 
 * @author Jorge Ramirez <jorge@codium.com.py>
 */
export let UICrudFormComponent = {
  transclude: {
    headerSlot: 'uiCrudHeader',
    formSlot: 'uiCrudBody',
    formTitleSlot: '?uiCrudTitle',
    headerButtonsSlot: '?uiCrudActions'
  },
  templateUrl: template,
  selector: 'uiCrudForm',
  bindings: {
    iconClasses: '@',
    // custom cancel function
    cancel: '<',

    // submit event callback
    doSubmit: '&',

    // indica a dónde redirigir luego del finalizar la creación/edición
    listState: '@',

    // indica si los campos van a estar en modo lectura
    view: '<',

    // hace referencia a la propiedad utilizada para indicar que se hizo submit del formulario
    submittedFlag: '='
  },
  controller: UICrudFormCtrl,
  controllerAs: 'vm'
};


UICrudFormCtrl.$inject = ['$state', '$transclude', '$element', '$scope'];

function UICrudFormCtrl($state, $transclude, $element, $scope) {
  this.setupTransclusion = setupTransclusion.bind(this);
  this.submit = submit.bind(this);

  this.$onInit = () => {

    this.setupTransclusion();

    if (this.cancel && !angular.isFunction(this.cancel)) {
      // eslint-disable-next-line no-console
      console.warn('La propiedad cancel debe ser una función');
    }

    if (!this.cancel || !angular.isFunction(this.cancel)) {
      this.cancel = cancel.bind(this);
    }
  };

  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go(this.listState);
  }

  function submit() {
    if ($scope.form && $scope.form.$invalid) {
      this.submittedFlag = true;
      return;
    }
    this.doSubmit();
  }

  /**
   * Este método se encarga de realizar los transclusions necesarios para que ui-crud-form
   * funcione. Si solo utilzamos ng-tranclude, las validaciones no van a funcionar ya que la
   * propiedad form termina en un scope distinto que el modelo de datos de los fields del 
   * formulario.
   */
  function setupTransclusion() {
    $scope.$watch('form', form => {
      let transcludeScope = $scope.$parent.$new();
      transcludeScope.form = form;
      let slots = ['headerSlot', 'formSlot', 'formTitleSlot'];

      for (let slot of slots) {
        $transclude(transcludeScope, clone => $element.find(`span[slot=${slot}]`).append(clone), null, slot);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/core/components/ui-crud/ui-crud-form/ui-crud-form.component.js